import { useEffect, useState } from 'react';
import { comprobarSalud, type Salud } from './salud';

/**
 * Fase 1: la base de la app publicada en su ambiente.
 *
 * La pantalla de acceso ya tiene la forma acordada —teléfono y PIN de seis
 * dígitos (docs/app_tecnicos.md, decisión 7)—, pero el botón no entra a
 * ningún lado: la cuenta del técnico, el rol y el endpoint de acceso son la
 * fase 2. Mientras tanto el botón dice por qué está apagado, como cualquier
 * otro del sistema (decisión 34 de CLAUDE.md).
 */

const ES_PRUEBAS =
  location.hostname.startsWith('qaapp.') || location.hostname === 'localhost';

function soloDigitos(texto: string, largo: number): string {
  return texto.replace(/\D/g, '').slice(0, largo);
}

export default function App() {
  const [telefono, setTelefono] = useState('');
  const [pin, setPin] = useState('');
  const [salud, setSalud] = useState<Salud>({ estado: 'comprobando' });

  useEffect(() => {
    const control = new AbortController();
    comprobarSalud(control.signal).then(setSalud).catch(() => {});
    return () => control.abort();
  }, []);

  const faltantes: string[] = [];
  if (telefono.length !== 10) faltantes.push('el teléfono a 10 dígitos');
  if (pin.length !== 6) faltantes.push('el PIN de 6 dígitos');

  return (
    <main className="pantalla">
      <header className="cabecera">
        <img src="/logo.png" alt="APRISA Mantenimiento Industrial" className="logo" />
        {ES_PRUEBAS && <span className="ambiente">Pruebas</span>}
      </header>

      <section className="tarjeta">
        <h1>Acceso de técnicos</h1>
        <p className="ayuda">Entra con el teléfono que tienes registrado en APRISA.</p>

        <form onSubmit={(e) => e.preventDefault()} noValidate>
          <label className="campo">
            <span>Teléfono</span>
            <input
              type="tel"
              inputMode="numeric"
              autoComplete="tel-national"
              placeholder="10 dígitos"
              value={telefono}
              onChange={(e) => setTelefono(soloDigitos(e.target.value, 10))}
            />
          </label>

          <label className="campo">
            <span>PIN</span>
            <input
              type="password"
              inputMode="numeric"
              autoComplete="current-password"
              placeholder="6 dígitos"
              value={pin}
              onChange={(e) => setPin(soloDigitos(e.target.value, 6))}
            />
          </label>

          <button type="submit" className="boton" disabled>
            Entrar
          </button>
          <p className="faltantes">
            {faltantes.length > 0
              ? `Falta ${faltantes.join(' y ')}. `
              : ''}
            El acceso todavía no está disponible: se habilita cuando se den de
            alta las cuentas de técnico.
          </p>
        </form>
      </section>

      <footer className={`conexion conexion-${salud.estado}`}>
        <span className="punto" aria-hidden="true" />
        {salud.estado === 'comprobando' && 'Comprobando la conexión…'}
        {salud.estado === 'ok' && 'Conectado al sistema'}
        {salud.estado === 'sin_base' && 'El servidor responde, pero no alcanza la base de datos.'}
        {salud.estado === 'sin_api' && salud.detalle}
      </footer>
    </main>
  );
}
